/*!
Copyright (c) 2013 Matthew Schinckel.
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define('ext/knockout.extender.cookie',['jquery', 'knockout', 'jquery.cookie'], function ($, ko) {
			return factory($, ko);
		});
	} else {
		// Browser globals
		factory(root.$, root.ko);
	}
}(this, function ($, ko) {

    ko.extenders.cookie = function (target, options) {
        var cookie_name, persist;
        if (typeof options === 'string') {
            cookie_name = options;
            persist = true;
        } else {
            cookie_name = options.name;
            persist = options.persist;
        }

        //set/restore the initial value  (only if cookie found; otherwise, leave original target value intact)
        var cookieValue = readCookie(cookie_name);
        if (cookieValue !== void 0) {
            target(cookieValue);
        }

        //Joseph Gabriel: added to allow external updates on the 'persist' observable to affect the cookie immediately
        ko.computed(function () {
            if (!ko.utils.unwrapObservable(persist)) {
                $.removeCookie(cookie_name);
            } else {
                writeCookie(cookie_name, target());
            }
        });

        function readCookie(key) {
            var value = $.cookie(key);
            if (value) {
                return JSON.parse(value);
            }
            return value;
        }

        function writeCookie(key, value) {
            if (value) {
                $.cookie(key, JSON.stringify(value));
            } else {
                $.cookie(key, value);
            }
        }


        return ko.computed({
            read: target,
            write: function (value) {
                // If our persist value returns true, then store in a cookie,
                // else remove a cookie with that name if one exists.
                if (ko.utils.unwrapObservable(persist)) {
                    writeCookie(cookie_name, value);
                } else {
                    $.removeCookie(cookie_name);
                }

                // If null or undefined was passed to the observable, then
                // unset the associated cookie.
                if (value === null || value === undefined) {
                    $.removeCookie(cookie_name);
                }

                target(value);
            }
        });
    };

}));
